<article class="mb-[12.8rem]">
  <div class="flex flex-col">
    <app-breadcrumb [items]="['PRESENTATION_TAB1_PARA_LIST4' | translate]"></app-breadcrumb>

    <section class="flex flex-col gap-[3rem]" aria-labelledby="admin-heading">
      <div class="flex flex-col sm:flex-row max-sm:gap-4 sm:justify-between w-full sm:items-center sm:px-[9.6rem] px-[7rem]">
        <h1 id="admin-heading" class="dsr-typescale-title-medium">
          {{ "PRESENTATION_TAB1_PARA_LIST4" | translate }}
        </h1>
        <div class="w-full sm:!h-[4rem] flex justify-start sm:justify-end">
          <mat-button-toggle-group class="!rounded-full !overflow-hidden" name="offerVariant" aria-label="Offer Variant"
            id="selOfferValue" [(ngModel)]="selectedVariant" (change)="changeSelectedVariant($event)">
            @for (variant of variantList; track variant; let i = $index) {
              <mat-button-toggle [checked]="variant.code === selectedVariant" [value]="variant.code"
                class="flex-1 flex items-center justify-center h-full transition-colors max-sm:!h-[6rem]">
                <span class="sm:hidden break-all" [ngClass]="{ 'dsr-typescale-body-small': variant.code !== selectedVariant,
                  'dsr-typescale-body-small-prominent': variant.code === selectedVariant }">
                  {{ variant.label | translate }}
                </span>
                <span class="dsr-typescale-body-small break-all hidden sm:inline" 
                  [ngClass]="{ 'dsr-typescale-body-small': variant.code !== selectedVariant,
                    'dsr-typescale-body-small-prominent': variant.code === selectedVariant }">
                    {{ variant.label | translate }}
                </span>
              </mat-button-toggle>
            }
          </mat-button-toggle-group>
        </div>
      </div>
      <div class="flex flex-col gap-10 sm:gap-6 sm:px-[9.6rem] px-[2rem] items-start">
        <div class="flex flex-row gap-36 w-full">
          @if(showOrgUsers) {
            <div class="flex sm:gap-4 gap-10 dsr-typescale-body-small py-10 sm:py-4 bg-light-dsr-color-highlight-container flex-col-reverse items-center justify-center w-full !rounded-md ">
              @if((userCount == userRegistrationCount) || (userCount == (userRegistrationCount-1)) || (isStatusInactive)) {
                <div class="flex flex-col sm:flex-row gap-10 sm:gap-32 px-20">
                  @if(userCount == userRegistrationCount) {
                    <div class="flex items-center gap-2">
                      <dsr-icon name="alert" size="2rem" class="!bg-light-dsr-color-error"></dsr-icon>
                      <span class="orgadmin-limit-msg ">{{ "ORGADMIN_LIMIT_EXCEEDED" | translate }}</span>
                    </div>
                  }
                  @if(userCount == (userRegistrationCount-1)) {
                    <div class="flex items-center gap-2">
                      <dsr-icon name="alert" size="2rem" class="!bg-light-dsr-color-warning"></dsr-icon>
                      <span class="orgadmin-limit-msg">{{ "ORGADMIN_LIMIT_EXCEED_WARNING" | translate }}</span>
                    </div>
                  }
                  @if(isStatusInactive) {
                    <div class="flex items-center gap-2">
                      <dsr-icon name="alert" size="2rem" class="!bg-light-dsr-color-error"></dsr-icon>
                      <span class="subStatusText">{{ "OFFER_EXPIRED_LABEL" | translate }}</span>
                    </div>
                  }
                </div>
              }
              <ul
                class="flex sm:flex-row flex-col gap-10 sm:gap-44 justify-center list-disc list-inside dsr-typescale-body-small w-full sm:items-center items-start max-sm:px-24">
                <li class="large-7 medium-6 text-center dsr-typescale-body-small small-12 total-orgusers">
                  {{ "ORGADMIN_TOTAL_USERS_LABEL" | translate }}<b>{{ userRegistrationCount }}</b>
                </li>
                <li class="large-7 dsr-typescale-body-small medium-6 text-center small-12 total-orgusers">
                  {{ "REGISTERED_USERS" | translate }}<b>{{ userCount }}/{{ userRegistrationCount }}</b>
                </li>
              </ul>
            </div>
          }

          @if(showAccessUsers) {
            <ul class="flex flex-col-reverse gap-10 sm:gap-4 sm:items-center list-disc py-10 sm:py-4 leading-[2.4rem] list-inside w-full bg-light-dsr-color-highlight-container !rounded-md">
              @if((ndUsers === ndAccessLimit) || (asmdorUsers === asmdorAccessLimit)) {
                <div class="sm:gap-52 gap-10 flex flex-col sm:flex-row max-sm:px-20">
                  @if(ndUsers === ndAccessLimit) {
                    <div class="flex items-center gap-2">
                      <dsr-icon name="alert" size="2rem" class="!bg-light-dsr-color-error"></dsr-icon>
                      <span class="orgadmin-limit-msg dsr-typescale-body-small">{{"REACH_MAX_ND_LIMIT" | translate}}</span>
                    </div>
                  }
                  @if((asmdorUsers === asmdorAccessLimit) && (getControls().length > 0 &&
                  getControls()[0].get('accessIdentifier')?.value !== 'INDADMIN')) {
                    <div class="flex items-center gap-2">
                      <dsr-icon name="alert" size="2rem" class="!bg-light-dsr-color-error"></dsr-icon>
                      <span class="orgadmin-limit-msg dsr-typescale-body-small">
                        {{"REACH_MAX_ASMDOR_LIMIT" | translate}}</span>
                    </div>
                  }
                </div>
              }
              <ul class="flex sm:flex-row flex-col items-start max-sm:px-24 sm:justify-center gap-10 sm:gap-44 list-inside list-disc">
                <li class="large-7 medium-6 max-sm:flex-1 text-center small-12 total-orgusers dsr-typescale-body-small">
                  {{ "USER_ACCESS_TO_ND" | translate }}
                  <b>{{ ndUsers }}/{{ ndAccessLimit }}</b>
                </li>
                @if(showAsmdorAccess) {
                <li class="large-7 medium-6 max-sm:flex-1 text-center small-12 total-orgusers dsr-typescale-body-small">
                  {{ "USER_ACCESS_TO_ASMDOR" | translate }}
                  <b>{{ asmdorUsers }}/{{ asmdorAccessLimit }}</b>
                </li>
                }
                <li class="large-7 medium-6 max-sm:flex-1 text-center small-12 total-orgusers dsr-typescale-body-small">
                  {{ "GLOBAL_LIMIT_RATE_LABEL" | translate }}:
                  <b>{{ globalRateLimit }}</b>
                </li>
              </ul>
            </ul>
          }
        </div>
      </div>
    </section>

    <!-- User management -->
    @if(showOrgUsers) {
      <section class="sm:px-[9.6rem] overflow-x-auto" aria-labelledby="user-table-caption">
        <form [formGroup]="addForm">
          <div class=" h-[60vh] overflow-y-auto">
            <table mat-table [dataSource]="getControls()" class="min-w-full mt-[2.5rem] !leading-[2.4rem]"
              aria-labelledby="user-table-caption">
              <caption id="user-table-caption" class="sr-only">
                Organization users management table
              </caption>
              <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef class="text-center w-[20rem] dsr-typescale-label-large-prominent">
                  {{ "ORGADMIN_HEADER_FIRSTNAME" | translate }}
                </th>
                <td mat-cell *matCellDef="let row"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ row.get("firstName")?.value }}
                </td>
              </ng-container>
              <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef class="text-center w-[20rem] dsr-typescale-label-large-prominent">
                  {{ "ORGADMIN_HEADER_LASTNAME" | translate }}
                </th>
                <td mat-cell *matCellDef="let row"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ row.get("lastName")?.value }}
                </td>
              </ng-container>
              <ng-container matColumnDef="userMail">
                <th mat-header-cell *matHeaderCellDef class="text-center w-[31rem] dsr-typescale-label-large-prominent">
                  {{ "ORGADMIN_HEADER_EMAIL" | translate }}
                </th>
                <td mat-cell *matCellDef="let row" class="text-center dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ row.get("userMail")?.value }}
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="text-center w-[14.5rem] dsr-typescale-label-large-prominent">
                  {{ "ORGADMIN_HEADER_STATUS" | translate }}
                </th>
                <td mat-cell *matCellDef="let row"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ row.get("status")?.value }}
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-[15rem] dsr-typescale-label-large-prominent">
                  Actions
                </th>
                <td mat-cell *matCellDef="let row">
                  @if(row.get('accessIdentifier')?.value !== 'INDADMIN' && row.get('accessIdentifier')?.value !== 'ORGADMIN') {
                  <div class="flex items-center justify-center first-letter:uppercase dsr-typescale-body-small">
                    <button type="button" [matMenuTriggerFor]="userActionsMenu" class="!cursor-pointer"
                      aria-label="User actions menu">
                      <dsr-icon name="more-horizontal" size="2.4rem" color="black"></dsr-icon>
                    </button>
                    <mat-menu #userActionsMenu="matMenu" class="user-actions-menu">
                      <button (click)="forgotPassword(row.get('userMail')?.value || '', row.get('status')?.value || '')"
                        mat-menu-item type="button">{{ "ACTIVATE_FORGOT_PASSWORD" | translate }}
                      </button>
                      <button (click)="userDelete(row.get('userMail')?.value || '', row.get('status')?.value || '')"
                        mat-menu-item type="button">{{ "ORGADMIN_DELETE" | translate }}
                      </button>
                      <button
                        (click)="selectActivateUser(row.get('userMail')?.value || '', row.get('status')?.value || '')"
                        mat-menu-item type="button">{{ "ACTIVATE_LABEL" | translate }}
                      </button>
                    </mat-menu>
                  </div>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="userDisplayedColumns; sticky: true" class="text-center"></tr>
              <tr mat-row *matRowDef="let row; columns: userDisplayedColumns"
                [ngClass]="{ disabled: disableDelete && row.get('status')?.value == 'Registered' }" class=""></tr>
            </table>
          </div>
        </form>
      </section>
    }

    @if(showOrgUsers) {
      <div class="sm:px-[9.6rem] px-[7rem] w-full mt-10">
        <div class="flex gap-[1.6rem] font-[600] text-[1.6rem]">
          <button mat-flat-button (click)="addNewUser()" [disabled]="userCount == userRegistrationCount">
            <span class="">{{ "ORGADMIN_ADD_USER_LABEL" | translate }}</span>
            <dsr-icon name="user" class="!h-7 !w-7 !bg-white"></dsr-icon>
          </button>
        </div>
      </div>
    }

    <!-- Access management -->

    @if(showAccessUsers) {
      <div class="w-full">
        <form [formGroup]="addForm">
          <div class="sm:px-[9.6rem] ">
            <div class="overflow-x-auto h-[60vh] overflow-y-auto">
              <table mat-table [dataSource]="getControls()" class="access-mgmnt min-w-full mt-[2.5rem] !leading-[2.4rem]"
                aria-labelledby="access-table-caption">
                <caption id="access-table-caption" class="sr-only">
                  Organization access management table
                </caption>
                <ng-container matColumnDef="firstName">
                  <th mat-header-cell *matHeaderCellDef
                    class="text-center w-[14.5rem] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                    {{ "ORGADMIN_HEADER_FIRSTNAME" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let row" class="text-center first-letter:uppercase dsr-typescale-body-small">
                    {{ row.get("firstName")?.value }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                  <th mat-header-cell *matHeaderCellDef
                    class="text-center w-[16.5rem] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                    {{ "ORGADMIN_HEADER_LASTNAME" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let row" class="text-center first-letter:uppercase dsr-typescale-body-small">
                    {{ row.get("lastName")?.value }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="userMail">
                  <th mat-header-cell *matHeaderCellDef
                    class="text-center w-[19rem] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                    {{ "ORGADMIN_HEADER_EMAIL" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let row" class="text-center dsr-typescale-body-small">
                    {{ row.get("userMail")?.value }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="ndAccess">
                  <th mat-header-cell *matHeaderCellDef
                    class="text-center w-[12rem] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                    {{ "ORGADMIN_HEADER_ND_ACCESS" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let row; let i = index"
                    class="text-center first-letter:uppercase dsr-typescale-body-small">
                    <mat-checkbox class="cursor-pointer justify-self-center" id="org-user-ND-{{ i }}"
                      [checked]="row.get('ndAccess')?.value" [formControl]="$any(row.get('ndAccess'))"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="asmdorAccess">
                  <th mat-header-cell *matHeaderCellDef
                    class="text-center w-[12rem] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                    {{ "ORGADMIN_HEADER_ASMDOR_ACCESS" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let row; let i = index"
                    class="text-center first-letter:uppercase dsr-typescale-body-small">
                    <mat-checkbox class="cursor-pointer justify-self-center" [checked]="row.get('asmdorAccess')?.value"
                      id="org-user-ASMDOR-{{ i }}" [formControl]="$any(row.get('asmdorAccess'))"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="rateLimit">
                  <th mat-header-cell *matHeaderCellDef
                    class="text-center w-[12rem] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                    {{ "LIMIT_RATE_LABEL" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let row" class="text-center first-letter:uppercase dsr-typescale-body-small">
                    {{ row.get("rateLimit")?.value }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="usage">
                  <th mat-header-cell *matHeaderCellDef
                    class="text-center w-[12rem] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                    {{ "USAGE_LABEL" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let row" class="text-center first-letter:uppercase dsr-typescale-body-small">
                    {{ row.get("usage")?.value }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef
                    class="text-center w-[15rem] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                    Actions
                  </th>
                  <td mat-cell *matCellDef="let row; let i = index"
                    class="text-center first-letter:uppercase dsr-typescale-body-small">
                    @if(row.get('accessIdentifier')?.value !== 'INDADMIN' && row.get('accessIdentifier')?.value !==
                    'ORGADMIN') {
                    @if(editingRowIndex != i) {
                    <button matIconButton (click)="startEditingRow(i, row, row.get('userMail')?.value)"
                      class="justify-self-center cursor-pointer">
                      <dsr-icon name="edit" size="2rem"></dsr-icon>
                    </button>
                    }
                    @if(editingRowIndex == i) {
                    <div>
                      <div class="flex items-center justify-center bg-su gap-[2rem]">
                        <!-- Bouton Confirmer -->
                        <button matIconButton (click)="confirmEditingRow(row)"
                          class=" !bg-light-dsr-color-success dsr-mat-icon-button-filled dsr-mat-icon-button-small">
                          <dsr-icon name="confirm" size="2.1rem" color="white"></dsr-icon>
                        </button>
                        <!-- Bouton Annuler -->
                        <button matIconButton (click)="cancelEditingRow()"
                          class=" !bg-light-dsr-color-error dsr-mat-icon-button-small dsr-mat-icon-button-filled">
                          <dsr-icon name="cancel" size="2rem" color="white"></dsr-icon>
                        </button>
                      </div>
                    </div>
                    }
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="accessDisplayedColumns; sticky: true" class="text-center"></tr>
                <tr mat-row *matRowDef="let row; columns: accessDisplayedColumns" [ngClass]="{ disabled: disableDelete }"
                  class=""></tr>
              </table>
            </div>
          </div>
        </form>
      </div>
    }
  </div>
  @if(orgAdminLoading) {
    <div class="!absolute bg-opacity-75 backdrop-blur-sm z-40 top-1/2 right-1/2">
      <mat-progress-spinner class="!h-[50px] !w-[50px]" mode="indeterminate" />
    </div>
  }
</article>